import {isMobileApp} from "./envNameUtils.ts";
import {LANDING_PAGE_URL} from "../../Globals.ts";

export const handleLinkClick = (event: any, environment: string, vscode: any, url: string) => {
    event.stopPropagation();
    event.preventDefault();

    if (environment.includes("jetbrains")) {
        event.preventDefault();

        window.jetbrainsPostMessage(JSON.stringify({
            functionName: "openLinkInBrowser",
            data: [{ url }]
        }));
    } else if (environment === "vscode") {
        event.preventDefault();
        vscode.postMessage({ functionName: "openLinkInBrowser", data: [{ url }] });
    } else if (isMobileApp(environment)) {
        event.preventDefault();

        window.ReactNativeWebView.postMessage(JSON.stringify({
            functionName: "openLinkInBrowser",
            data: [{ url }]
        }));
    } else {
        window.open(url, '_blank');
    }
};

export const openSubscribe  = (event: any, environment: string, vscode: any) => {
    event.stopPropagation();

    if (environment.includes("jetbrains")) {
        event.preventDefault();

        window.jetbrainsPostMessage(JSON.stringify({
            functionName: "openLinkInBrowser",
            data: [{url: `${LANDING_PAGE_URL}/pricing`}]
        }));
    } else if (environment === "vscode") {
        event.preventDefault();
        vscode.postMessage({ functionName: "openLinkInBrowser", data: [{url: `${LANDING_PAGE_URL}/pricing`}] });
    } else if (isMobileApp(environment)) {
        event.preventDefault();

        window.ReactNativeWebView.postMessage(JSON.stringify({
            functionName: "openLinkInBrowser",
            data: [{url: `${LANDING_PAGE_URL}/pricing`}]
        }));
    } else {
        window.open(`${LANDING_PAGE_URL}/pricing`, '_blank');
    }
};

export const clickFileLink = (e: any, environment: string, vscode: any, filePath: string) => {
    if (!filePath?.startsWith("http")) {
        e.preventDefault();
        if (environment.includes('jetbrains')) {
            window.jetbrainsPostMessage(JSON.stringify({
                functionName: "openFileInIde",
                data: [{filePath}]
            }));
        } else if (environment === "vscode") {
            vscode.postMessage({
                functionName: "openFileInIde",
                data: [{filePath}]
            });
        }
    } else if (filePath) {
        handleLinkClick(e, environment, vscode, filePath);
    }
};